import { IHttpService, IPromise } from 'angular';
import HttpService from '../../common/services/http.service';


/* @ngInject */
export class AdjustEventService {
    constructor(
        private $http: IHttpService,
        private httpService: HttpService,
        private config,
        private i18n
    ) {
    }


    public postEvent(eventType: string, currency: string, revenue: string): IPromise<boolean> {      
        var adId = localStorage.getItem('advertisementId');
        var gpAdid = localStorage.getItem('gp_adid');
        var encryptedMsisdn = localStorage.getItem('encryptedMsisdn');
        if(!!adId){
            return this.httpService.extractResponseResult(
            this.$http.post(
                `hafifmuzik/mobile/ad-event/track` ,
                {eventType: eventType, currency: currency, revenue:revenue, adId: adId, gpAdid: gpAdid, encryptedMsisdn: encryptedMsisdn}
            )
            );
        }
    }
    
}


// WEBPACK FOOTER //
// ./src/app/buy/services/adjust-event.service.ts